import { KeyboardEvent, MouseEvent, useCallback, useEffect, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import useUiuxStore from "src/store/useUiuxStore"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"


import { AgGridReact } from "ag-grid-react"
import { Content_PRD2010_R01 } from "./Content_PRD2010_R01"
import { PRD2010_R01Dto } from "./Dto_PRD2010_R01"
import { SearchSection_PRD2010_R01 } from "./SearchSection_PRD2010_R01"
import { usePRD2010_R01Store } from "./Store_PRD2010_R01"
import { Table_PRD2010_R01 } from "./Table_PRD2010_R01"
import { Modal_PRD2010_R01 } from "./Modal_PRD2010_R01"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_PRD2010_R01 = () => {
	const { 
		PRD2010_R01List,
		insertPRD2010_R01List,
		initData,
		modalVisible, setModalVisible,
	} = usePRD2010_R01Store();
	const { setMessage } = useUiuxStore();
	
	const gridRef = useRef<AgGridReact<PRD2010_R01Dto> | null>(null);

	const modalRef = useRef<HTMLDivElement>(null);

	const {
		clickable, setClickable,
		handleExcelClick,
		handlePrintClick,
		fetchData,
		defaultPRD2010_R01Row,
		initContainerData,
		handleInsertClick,
		handleDeleteClick,
		handleSaveClick,
		buttonDisabled,
	} = Content_PRD2010_R01({
		gridRef,
		setMessage,
		
	});

	
	useEffect(() => { 
		if (PRD2010_R01List.length === 0) { handleInsertClick({} as MouseEvent<HTMLButtonElement>); setClickable(true);}
	}, [PRD2010_R01List, handleInsertClick]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onPrintClick={handlePrintClick}
			onInitClick={initContainerData}
		/>
		
		<SearchSection_PRD2010_R01
			onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
				if (e.key === 'Enter') {
					fetchData()
				}
			}} 
		/>
		{modalVisible && <Modal_PRD2010_R01 modalRef={modalRef} />}
		<div className="flex-1 flex">
			<div className="w-full h-full flex flex-col  p-[12px] gap-[12px]">
				
				<Table_PRD2010_R01
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
					defaultPRD2010_R01Row={defaultPRD2010_R01Row()}
				/>
			</div>
		</div>
		{/* 메시지 표시 컴포넌트 */}
		<Message />
	</div>
}